import "bootstrap/dist/css/bootstrap.min.css";

import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import {
  Container,
  Form,
  Image,
  InputGroup,
  Modal,
  Spinner
} from "react-bootstrap";

import logo from "../../../assets/images/MTDlogo.png";
import backarrow from "../../../assets/images/backarrow.jpg";
import responsivebg from "../../../assets/images/responsive-bg.png";

import "./job-title.css";

import Stepper from "../Stepper";
import { API_URL } from "../../../api";
import { useCookies } from "../../../hooks/useCookies";
import { useAlert } from '../../../Context/AlertModalContext';

export default function Personality() {
  const isFetched = useRef(false);
  const [searchTerm, setSearchTerm] = useState("");
  const personalityListEndRef = useRef(null);
  const [hasAddedPersonality, setHasAddedPersonality] = useState(false);
  const [personalities, setPersonalities] = useState([]);
  const { getCookie } = useCookies();
  const token = getCookie("token");
  const [selectedPersonalities, setSelectedPersonalities] = useState([]);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const alert = useAlert();
  const [loading, setLoading] = useState(false);

  const filteredPersonality = personalities.filter((p) =>
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const fetchPersonalityOptions = useCallback(() => {
    fetch(`${API_URL}customer/users/personality-options`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.personalities) {
          setPersonalities(data.personalities);
        }
      })
      .catch((error) => console.error("Error fetching location:", error));
  }, [token]);

  const fetchPersonalities = useCallback(() => {
    fetch(`${API_URL}customer/users/personalities`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.personalities) {
          setSelectedPersonalities(data.personalities);
        }
      })
      .catch((error) => console.error("Error fetching location:", error));
  }, [token]);

  useEffect(() => {
    if (isFetched.current) return;
    isFetched.current = true;

    if (!token) return;
    fetchPersonalityOptions();
    fetchPersonalities();
  }, [token, personalities, selectedPersonalities, personalities, fetchPersonalityOptions, fetchPersonalities]);



  useEffect(() => {
    if (hasAddedPersonality && personalityListEndRef.current) {
      personalityListEndRef.current.scrollIntoView({ behavior: "smooth" });
      setHasAddedPersonality(false);
    }
  }, [hasAddedPersonality]);

  async function savePersonalities() {
    if (selectedPersonalities?.length < 3 || selectedPersonalities?.length > 8) {
      setShowModal(true);
      return;
    }
    setLoading(true)
    const response = await fetch(`${API_URL}customer/users/personality`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify({
        personalities: selectedPersonalities.map((p) => p.id),
      }),
    });
    await response.json();
    if (response.ok) {
      setLoading(false)
      navigate("/profile-answers");
    } else {
      setLoading(false)
    }
  }
  const handlePersonalityClick = (personality) => {
    const isAlreadySelected = selectedPersonalities.find(
      (p) => p.name === personality.name
    );

    if (isAlreadySelected) {
      setSelectedPersonalities(
        selectedPersonalities.filter((p) => p.name !== personality.name)
      );
    } else {
      if (selectedPersonalities?.length >= 8) {
        alert.setModal({
          title: "",
          message: "You cannot select more than 8 options.",
          show: true,
        });
        return;
      }

      setSelectedPersonalities([...selectedPersonalities, personality]);
    }
  };

  return (
    <div className="job-container">
      <div className="job-bg">
        <Image
          className="responsive-bg"
          src={responsivebg}
          alt="Background"
        ></Image>
      </div>
      <Container className="job-main">
        <Container className="job-content">
          <Container className="logo-progressbar10">
            <Container className="logo-arrow10">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()}
                alt="Back Arrow"
              />
              <Image
                src={logo}
                alt="Logo"
                className="logo"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
            <Stepper activeStep="Personality" />
          </Container>
          <div className="container-div">
            <Container className="job-details">
              <div className="container-child1">
                <div className="your-job">
                  <Container className="job-text">
                    <p>How would you describe your personality?</p>
                  </Container>
                  <InputGroup
                    className="job-search-bar"
                    style={{
                      overflow: "hidden",
                    }}
                  >
                    <Form.Control
                      className="job-search"
                      type="text"
                      placeholder="Search"
                      value={searchTerm}
                      style={{
                        border: "none",
                        outline: "none",
                        height: "100%",
                      }}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <InputGroup.Text
                      className="search-icon"
                      style={{
                        position: "relative",
                        top: "0rem",
                      }}
                    >
                      <IoIosSearch />
                    </InputGroup.Text>
                  </InputGroup>
                  <div>
                    {selectedPersonalities?.length < 3 ||
                      selectedPersonalities?.length > 8 ? (
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#4E1173",
                          lineHeight: "18.5%",
                          marginBottom: "20px",
                        }}
                      >
                        Please select 3-8 options only.
                      </p>
                    ) : null}
                  </div>
                  <div className="personality-selected">
                    {selectedPersonalities.map((personality, index) => (
                      <div
                        key={index}
                        className="job-item-select"
                        style={{
                          backgroundColor: selectedPersonalities?.find(
                            (p) => p.name === personality.name
                          )
                            ? "rgb(179 73 245)"
                            : "transparent",
                          color: "#fff",
                          margin: "3px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>{personality.name}</span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedPersonalities(
                              selectedPersonalities.filter(
                                (p) => p !== personality
                              )
                            );
                          }}
                          style={{
                            cursor: "pointer",
                            color: "#fff",
                            backgroundColor: "gray",
                            borderRadius: "50%",
                            padding: "0 5px",
                            marginTop: "-50px",
                            marginRight: "-15px",
                          }}
                        >
                          ✖
                        </span>
                      </div>
                    ))}
                  </div>

                  <div className="job-colums personality-types">
                    <div
                      className="job-columns"
                      style={{
                        marginRight: "10px",
                        maxHeight: "40vh",
                      }}
                    >
                      {[...filteredPersonality]
                        .sort((a, b) => {
                          const aSelected = selectedPersonalities.some(
                            (p) => p.name === a.name
                          );
                          const bSelected = selectedPersonalities.some(
                            (p) => p.name === b.name
                          );
                          if (aSelected && !bSelected) return -1;
                          if (!aSelected && bSelected) return 1;
                          return 0;
                        })
                        .map((personality, index) => (
                          <div
                            key={index}
                            className="job-item"
                            onClick={() => handlePersonalityClick(personality)}
                            style={{
                              backgroundColor: selectedPersonalities.find(
                                (p) => p.name === personality.name
                              )
                                ? "#F7ECFF"
                                : "transparent",
                            }}
                          >
                            {personality.name}
                          </div>
                        ))}
                      <div ref={personalityListEndRef} />
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <div className="d-flex justify-content-center next-btn">
            <button
              type="submit"
              className="global-next-bottom-fix-btn"
              onClick={savePersonalities}
              disabled={loading}
            >
              {loading ? (
                <Spinner animation="border" size="sm" role="status" />
              ) : (
                "Next"
              )}
            </button>
          </div>
        </Container>

        <Modal
          centered
          className="customer-modal-without-header-footer selfie-modal"
          show={showModal}
          onHide={() => setShowModal(false)}
        >
          <Modal.Body className="selfie-modal-body">
            Please select between 3 and 8 personalities. Selections below 3 or
            above 8 are not allowed.
            <button
              className="global-save-button"
              onClick={() => setShowModal(false)}
            >
              Okay
            </button>
          </Modal.Body>
        </Modal>
      </Container>
    </div>
  );
}
